export const MOBILE_BREAKPOINT = "600px";
export const TABLET_BREAKPOINT = "1200px";
export const LIGHT_GREY = "#E7E9E9";
export const LIGHT_TAN = "#FFEFDF";

export const ELIGIBILITY_STATUS = {
  YES: "Y",
  NO: "N",
};

export const COUNTRY_CODES_THREE_LETTER = {
  USA: "USA",
  CAN: "CAN",
};

export const ELIGIBLE_ALIAS = new Set(["mikcla"]);

export const ALLEGRO_CHECK_ELIGIBILITY_BUTTON_EVENT =
  "ALLEGRO_CHECK_ELIGIBILITY_BUTTON_CLICK_EVENT";

export const ALLEGRO_PURCHASE_LINK_EVENT = "ALLEGRO_PURCHASE_LINK_EVENT";

export const PROCESS_PATH = "PROCESS_PATH";

export const IS_ELIGIBLE = "IS_ELIGIBLE";

export const HEADPHONE_TYPE = "HEADPHONE_TYPE";